import { useSyncExternalStore } from "react";

export function useMediaQueryServerSnapshot(): boolean {
  return false;
}

// Cache subscribe / getSnapshot factories per media query string. Without this,
// `useMediaQuery` calls `subscribe(query)` / `getSnapshot(query)` on every render,
// useSyncExternalStore sees fresh function references, and tears down + rebuilds
// the matchMedia listener every cycle. Keying by `query` (a stable string per
// caller) gives us one shared listener per query for the lifetime of the page.
const subscribeCache = new Map<string, (notify: () => void) => () => void>();
const snapshotCache = new Map<string, () => boolean>();

function getSubscribe(query: string) {
  const cached = subscribeCache.get(query);
  if (cached) return cached;
  const fn = (notify: () => void) => {
    if (typeof window === "undefined") return () => undefined;
    const mediaQueryList = window.matchMedia(query);
    mediaQueryList.addEventListener("change", notify);
    return () => mediaQueryList.removeEventListener("change", notify);
  };
  subscribeCache.set(query, fn);
  return fn;
}

function getSnapshot(query: string) {
  const cached = snapshotCache.get(query);
  if (cached) return cached;
  const fn = () => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  };
  snapshotCache.set(query, fn);
  return fn;
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(getSubscribe(query), getSnapshot(query), useMediaQueryServerSnapshot);
}
